import { useUser } from "../../../services/auth";
import LocalStorage from "../../../services/LocalStorage";
import { HttpMethod } from "../../../types/http";
import useRequest from "../useRequest";

type useTermsAndConditionsQueryResponse = { tcAccepted: boolean };

export const TERMS_AND_CONDITIONS_API = "/cosmos/user/terms-and-conditions/";

export const useTermsAndConditionsQuery = () => {
  const token = LocalStorage.getAccessToken();
  const { isLoggedIn } = useUser();

  /**
   * Only fetch if the user is logged in.
   */
  const shouldFetch = token && isLoggedIn;

  return useRequest<useTermsAndConditionsQueryResponse>(
    shouldFetch
      ? {
          method: HttpMethod.GET,
          url: TERMS_AND_CONDITIONS_API,
        }
      : null
  );
};
